import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import WhyChooseUsService from '../../services/why-choose-us.service';
import styles from './WhyChoooseTnh.module.css';

export default function SlideHome() {
    const {locale} = useRouter();
    const [whyChooseList, setWhyChooseList] = useState([]);

    const index2ClassName = index => {
        switch (index) {
            case 0:
                return styles['card-bottom-right-no-rounded'];
            case 1:
                return styles['card-bottom-left-no-rounded'];
            case 2:
                return '';
            case 3:
                return styles['card-top-right-no-rounded'];
            case 4:
                return styles['card-top-left-no-rounded'];
            case 5:
                return styles['card-bottom-right-no-rounded'];
            default:
                return '';
        }
    };

    useEffect(() => {
        const whyChooseUsService = new WhyChooseUsService();
        whyChooseUsService
            .getWhyChooseList({locale})
            .then(response => {
                setWhyChooseList(response);
            })
            .catch(error => {
                console.error('Error fetching why choose us data:', error);
            });
    }, [locale]);

    return (
        <>
            <section className="why" id="why-tnh" aria-labelledby="why-title">
                <div className="container">
                    <h2 className="why__title" id="why-title">
                        {getLocaleContent(locale, 'page.why-choose.title1')}{' '}
                        <span>{getLocaleContent(locale, 'page.why-choose.title2')}</span>{' '}
                        {getLocaleContent(locale, 'page.why-choose.title3')}
                    </h2>

                    <div className={styles['container']}>
                        <figure className={`why__photo ${styles['card']}`}>
                            <img src={whyChooseList[0]?.image_url} alt="Bệnh viện TNH" />
                        </figure>

                        {whyChooseList
                            .filter((item, index) => index != 0)
                            .map((item, index) =>
                                item.type === 'image' ? (
                                    <aside
                                        key={index}
                                        className={`${
                                            item.is_highlight ? styles['card-highlighted'] : styles['card-bordered']
                                        } ${index2ClassName(index)}`}>
                                        <img src={item.image_url} alt={item.title || ''} />
                                    </aside>
                                ) : (
                                    <article
                                        key={index}
                                        className={`${
                                            item.is_highlight ? styles['card-highlighted'] : styles['card']
                                        } ${index2ClassName(index)}`}>
                                        <h3>{item.title || ''}</h3>
                                        <p>{item.description || ''}</p>
                                    </article>
                                ),
                            )}
                    </div>

                    <div className="why__more">
                        <button className="why__more-btn" onClick={() => (window.location.href = '/gioi-thieu')}>
                            {getLocaleContent(locale, 'common.discover-more')}
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
}
